import { render } from "./SubNavigation.vue?vue&type=template&id=472040b4&scoped=true"
import script from "./SubNavigation.vue?vue&type=script&lang=js"
export * from "./SubNavigation.vue?vue&type=script&lang=js"

import "./SubNavigation.vue?vue&type=style&index=0&id=472040b4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-472040b4"]])

export default __exports__